import img1 from './biotechnology-specialist-laboratory-conducting-experiments.jpg';
import img2 from './biotechnology-specialist-laboratory-conducting-experiments (2).jpg';
import img3 from './alexandra-lee-AXRHYAYClnA-unsplash.jpg';
import img4 from './biotechnology-specialist-laboratory-conducting-experiments (1).jpg';
import img5 from './prasesh-shiwakoti-lomash-7XvputByH_M-unsplash.jpg';
// import img6 from './6.png';

const images = [img1, img2, img3, img4, img5];
export default images;
